<template>
  <div
    v-b-tooltip.hover
    :title="$t('global.click_to_expand')"
    v-html="results"
    class="pointer"
    @click="expand = !expand">
  </div>
</template>

<script>

  export default {
    name: 'ColumnExtraExpand',
    props: ['row', 'column'],
    data: () => {
      return {
        expand: false
      }
    },
    methods: {},
    computed: {
      results: {
        cache: false,
        get: function () {
          const items = this.row[this.column];
          let itemsHtml = '';

          if (this.expand) {
            items.forEach((item, index) => {
                itemsHtml += `<b>${item.title}</b>`;
                itemsHtml += `<br>`;
                itemsHtml += `<b>Terms:</b> <br>`;
                item.terms.forEach(term => {
                  itemsHtml += `${term.title}`;
                  itemsHtml += `<br>`;
                });
                itemsHtml += index < items.length - 1 ? `<hr/>` : ``;
              }
            );
          } else {
            itemsHtml += items.length?`<b>${items[0].title}</b>`:``;
          }
          return itemsHtml
        }
      }
    }
  }
</script>
